import React from 'react'
import { useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, Badge, Alert, UncontrolledTooltip } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ListEmployeeApi } from "../../../services/Api";
import { genericGet, genericPost } from "../../../services/Api";
import { EbmsLoading, log } from "../../../services/Utils";
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import '../../../tabler.css'; // Local copy
import { IconCancel, IconEyeDollar, IconMinus, IconPlus, IconUser, IconX, IconHelpCircle } from '@tabler/icons-react'; // Optional icons

import { SUCCESS_RESULT, ENDPOINTS } from "../../../Constants";
import { FaFileImport, FaTimes, FaEdit, FaFileExport, FaUser, FaPlusCircle, FaTimesCircle, FaSave, FaAd, FaHistory, FaEye, FaArrowAltCircleRight, FaCheckCircle, FaArrowCircleLeft } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./payrollProcessing.css";

 

const ProcessPayroll = () => {
  const toggle = () => setshowModal(!showModal);
  const toggle2 = () => setshow_alloc_details(!show_alloc_details);
  const toggle3 = () => setshow_create_track_modal(!show_create_track_modal);


  const [isLoading, setIsLoading] = useState(false);


  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const [showModal, setshowModal] = useState(false)
  const [selected_staff, setselected_staff] = useState(null)
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [project_codes, setproject_codes] = useState([])
  const [selected_project, setselected_project] = useState(null)
  const [selected_line, setselected_line] = useState(null)
  const [contracted_salary, setcontracted_salary] = useState(0)
  const [amount, setamount] = useState(0)
  const [percentage, setpercentage] = useState(0)
  const [form_data, setForm_data] = useState({})
  const [previous_allocs, setprevious_allocs] = useState([])
  const [lines, setlines] = useState([])
  const [year, setyear] = useState(null)
  const [month, setmonth] = useState(null);
  const [details_allocations, setDetails_allocations] = useState([])
  const [show_alloc_details, setshow_alloc_details] = useState(false)
  const [payroll_tracks, setpayroll_tracks] = useState([])
  const [show_create_track_modal, setshow_create_track_modal] = useState(false)
  const [track_name, setTrack_name] = useState("")
  const [payroll_staff_list, setPayroll_staff_list] = useState([])
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorData, setErrorData] = useState(null)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const showErrorDialog = (errorResponse) => {
    setErrorData(errorResponse);
    setShowErrorModal(true);
  }

  const calculatePayrollAmounts = () => {
    if (!selectedPayrollStaff) return { gross: 0, deductions: 0, net: 0 };
    
    // TOTAL PAYROLL AMOUNT = total_staff_payroll + adjusted earnings
    const totalPayrollAmount = selectedPayrollStaff?.total_staff_payroll + selectedEarnings.reduce(
      (sum, d) => sum + parseFloat(d.amount || 0), 0
    );
    
    // Tax
    const tax = getTotalTaxes();
    
    // Adjusted deductions = existing adjusted deductions + newly added deductions
    const existingAdjustedDeductions = (selectedPayrollStaff?.earnings?.adjusted_deduction?.adjusted_deduction?.reduce(
      (sum, a) => sum + parseFloat(a?.amount || 0), 0
    ) || 0);
    const newAdjustedDeductions = selectedDeductions.reduce(
      (sum, d) => sum + parseFloat(d.amount || 0), 0
    );
    const adjustedDeductions = existingAdjustedDeductions + newAdjustedDeductions;
    
    // Total deductions for display (includes all deductions)
    const totalDeductions = adjustedDeductions + tax + (selectedPayrollStaff?.deductions?.other_deductions?.other_deductions_total || 0);
    
    // net_pay = TOTAL PAYROLL AMOUNT - tax - adjusted deductions
    const netPay = totalPayrollAmount - tax - adjustedDeductions;
  
    return {
      gross: totalPayrollAmount,
      deductions: totalDeductions,
      net: netPay,
      tax: tax,
      adjustedDeductions: adjustedDeductions,
      totalPayrollAmount: totalPayrollAmount
    };


  }

  const handleSavePayrollClick = () => {
    setShowConfirmModal(true);
  }

  const handleConfirmSave = () => {
    // Don't close modal immediately, let it stay open to show progress
    save_payroll(10003);
  }
  const [page, setPage] = useState(1)
  const [selectedPayrollStaff, setSelectedPayrollStaff] = useState(null)
  const [selected_track_id, setSelected_track_id] = useState([]);
  const [selected_track_name, setSelected_track_name] = useState([]);
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([]);

  const [earning_list, setEarningList] = useState([])
  const [deduction_list, setDeductionList] = useState([])

  // State for selected earnings
  const [selectedEarnings, setSelectedEarnings] = useState([]);
  const [selectedEarningId, setSelectedEarningId] = useState("");

  // State for selected deductions
  const [selectedDeductions, setSelectedDeductions] = useState([]);
  const [selectedDeductionId, setSelectedDeductionId] = useState("");
  const [deductionAmount, setDeductionAmount] = useState("");
  const [deductionRemarks, setDeductionRemarks] = useState("");
  const [selectedTaxes, setSelectedTaxes] = useState([]);

  //ADJUSTMENT EARNING MODAL
  const [show_adjustment_earning_modal, setShowAdjustmentEarningModal] = useState(false);
  const [show_adjustment_deduction_modal, setShowAdjustmentDeductionModal] = useState(false);
  // const [selected_adjustment_earning, setSelectedAdjustmentEarning] = useState(null);
  // const [selected_adjustment_deduction, setSelectedAdjustmentDeduction] = useState(null);




  // Handle adding a new earning to the selected_earnings array
  const handleAddEarning = () => {
    if (!selectedEarningId) return;

    const selectedEarning = earning_list.find((e) => e.id === selectedEarningId);
    if (selectedEarning) {
      const newEarning = {
        ...selectedEarning,
        amount: "",
        remarks: "",
      };
      setSelectedEarnings([...selectedEarnings, newEarning]);
      setSelectedEarningId(""); // Reset dropdown
    }
  };

  // Handle adding a new deduction to the selected_deductions array
  const handleAddDeduction = () => {
    if (!selectedDeductionId) {
      cogoToast.error("Please select a deduction type", {});
      return;
    }

    const selectedDeduction = deduction_list.find((d) => d.id === selectedDeductionId);
    if (selectedDeduction) {
      const newDeduction = {
        ...selectedDeduction,
        amount: deductionAmount || "",
        remarks: deductionRemarks || "",
      };
      setSelectedDeductions([...selectedDeductions, newDeduction]);
      setSelectedDeductionId(""); // Reset dropdown
      setDeductionAmount(""); // Reset amount
      setDeductionRemarks(""); // Reset remarks
    }
  };

  // Handle updating Amount or Remarks for a specific earning
  const handleUpdateEarning = (id, field, value) => {
    const updatedEarnings = selectedEarnings.map((earning) =>
      earning.id === id ? { ...earning, [field]: value } : earning
    );
    setSelectedEarnings(updatedEarnings);
  };

  // Handle updating Amount or Remarks for a specific deduction
  const handleUpdateDeduction = (id, field, value) => {
    const updatedDeductions = selectedDeductions.map((deduction) =>
      deduction.id === id ? { ...deduction, [field]: value } : deduction
    );
    setSelectedDeductions(updatedDeductions);
  };

  // Handle removing an earning from the selected_earnings array
  const handleRemoveEarning = (id) => {
    const updatedEarnings = selectedEarnings.filter((earning) => earning.id !== id);
    setSelectedEarnings(updatedEarnings);
  };

  // Handle removing a deduction from the selected_deductions array
  const handleRemoveDeduction = (id) => {
    const updatedDeductions = selectedDeductions.filter((deduction) => deduction.id !== id);
    setSelectedDeductions(updatedDeductions);
  };

  useEffect(() => {
    fetch_data();
    loadProjects();
    listTracks();
    get_tags();
    get_deductions();
    get_earnings();
    return () => { };
  }, []);

  // Auto-add total benefits as adjusted deduction when user is selected
  useEffect(() => {
    if (!selectedPayrollStaff) {
      // Clear deductions when no staff is selected
      setSelectedDeductions([]);
      setSelectedTaxes([]);
      return;
    }

    // Wait for deduction_list to be loaded
    if (deduction_list.length === 0) {
      return;
    }

    // Clear existing adjusted deductions
    setSelectedDeductions([]);

    // Calculate total benefits (retirement benefits)
    const totalBenefits = (selectedPayrollStaff?.earnings?.retirement_benefits?.retirement_benefits?.reduce(
      (sum, benefit) => sum + parseFloat(benefit?.amount || 0), 0
    ) || 0);

    // Only add deduction if there are benefits
    if (totalBenefits > 0) {
      // Find a deduction with "Gratuity" in the name, or use the first deduction
      const gratuityDeduction = deduction_list.find(d => 
        d.title && d.title.toLowerCase().includes('gratuity')
      ) || deduction_list[0];

      if (gratuityDeduction) {
        const benefitsDeduction = {
          ...gratuityDeduction,
          amount: totalBenefits.toFixed(2),
          remarks: "Auto-calculated from total benefits (Gratuity)",
        };
        setSelectedDeductions([benefitsDeduction]);
      }
    }
  }, [selectedPayrollStaff, deduction_list]);

  useEffect(() => {
    if (!selectedPayrollStaff) {
      setSelectedTaxes([]);
      return;
    }

    const taxes = selectedPayrollStaff?.deductions?.taxes?.taxes || [];
    setSelectedTaxes(
      taxes.map((tax, index) => ({
        ...tax,
        id: tax?.id || `tax-${index}`,
        amount: tax?.amount ?? 0,
      }))
    );
  }, [selectedPayrollStaff]);

  const handleUpdateTax = (id, value) => {
    const updatedTaxes = selectedTaxes.map((tax) =>
      tax.id === id ? { ...tax, amount: value } : tax
    );
    setSelectedTaxes(updatedTaxes);
  };

  const getTotalTaxes = () =>
    selectedTaxes.reduce((sum, tax) => sum + parseFloat(tax.amount || 0), 0);

  const updateData = e => {
    setForm_data({
      ...form_data,
      [e.target.name]: e.target.value
    })
  }



  const removeLine = (budget_line) => {
    let _lines = lines;
    _lines = _lines.filter(function (obj) {
      return obj.budget_line !== budget_line;
    })
    setlines([]);
    setlines(_lines);

  }


  const get_detailed_alloc_total_percentage = () => {

    let total = 0;
    details_allocations.forEach((l) => {
      total = Number(total) + Number(l.percentage);
    })
    return total.toFixed(2);

  }
  const get_detailed_alloc_total_amount = () => {

    let total = 0;
    details_allocations.forEach((l) => {
      total = Number(total) + Number(l.amount);
    })
    return total.toFixed(2);

  }

  const get_prev_alloc_total_percentage = () => {

    let total = 0;
    previous_allocs.forEach((l) => {
      total = Number(total) + Number(l.percentage);
    })
    return total.toFixed(2);

  }
  const get_prev_alloc_total_amount = () => {

    let total = 0;
    previous_allocs.forEach((l) => {
      total = Number(total) + Number(l.amount);
    })
    return total.toFixed(2);

  }
  const get_prev_alloc_total_balance = () => {

    let total = 0;
    previous_allocs.forEach((l) => {
      total = Number(total) + Number(l.balance);
    })
    return total.toFixed(2);

  }

  const handleCheckboxChange = (event) => {
    const value = event.target.value;

    if (event.target.checked) {
      // Add the id to selectedItems if checked
      setSelectedTags([...selectedTags, value]);
    } else {
      // Remove the id from selectedItems if unchecked
      setSelectedTags(selectedTags.filter((item) => item !== value));
    }
  };

  const add_budget = (e) => {
    e.preventDefault();


    // validations
    if (form_data?.project_id == null || form_data?.budget_line == null) {
      cogoToast.error("Please Select Budget line ", {
        hideAfter: 5,
      });
      return;
    }

    let line_exist = lines.filter(function (obj) {
      return obj.budget_line == form_data?.budget_line;
    });

    if (line_exist?.length > 0) {
      cogoToast.error("Budget line already added  ", {
        hideAfter: 5,
      });
      return;
    }
    if (!form_data?.amount > 0) {
      cogoToast.error("Amount should be greater than Zero. ", {
        hideAfter: 5,
      });
      return;
    }


    // if(Number(get_total_percentage())+Number(form_data?.percentage) > 100){
    //   cogoToast.error("Percentage could not Exceed 100%  " , {
    //     hideAfter: 5,
    // });
    // return;
    // }




    // END OF VALIDATIONS
    let _lines = lines;


    form_data.month = month;
    form_data.year = year;

    setlines([]);
    _lines.push(form_data);
    setTimeout(() => {

      setlines(_lines);
      document.getElementById("form").reset();
      setForm_data(null)
    }, 100);



  }

  const remove_account = () => {

  }

  const save_payroll = (status) => {



    const updatedSelectedEarnings = selectedEarnings.map((earning) => {
      const { id, ...rest } = earning; // Destructure to separate `id` from other properties
      return {
        ...rest, // Include all other properties
        earning_id: id, // Rename `id` to `earning_id`
      };
    });
    const updatedSelectedDeductions = selectedDeductions.map((deduction) => {
      const { id, ...rest } = deduction; // Destructure to separate `id` from other properties
      return {
        ...rest, // Include all other properties
        deduction_id: id, // Rename `id` to `deduction_id`
      };
    });
    const updatedSelectedTaxes = selectedTaxes.map((tax) => {
      const { id, ...rest } = tax;
      return {
        ...rest,
        tax_id: id,
        amount: parseFloat(tax.amount || 0),
      };
    });

    setIsLoading(true);
    genericPost(ENDPOINTS.SAVE_PAYROLL, {
      "track_id": selected_track_id,
      "status": status,
      "employees": [
        {
          "id": selectedPayrollStaff?.staff_details?.id,
          "adjusted_earning": updatedSelectedEarnings,
          "adjusted_deduction": updatedSelectedDeductions,
          "taxes": updatedSelectedTaxes,
          "total_taxes": getTotalTaxes(),
        }

      ]
    })
      .then((res) => {
        console.log(res)
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {
            cogoToast.success("Payroll save successfully for " + selectedPayrollStaff?.staff_name, {});
            
            // Remove the successfully processed staff from the grid
            const updatedStaffList = payroll_staff_list.filter(
              staff => staff.staff_details?.id !== selectedPayrollStaff?.staff_details?.id
            );
            setPayroll_staff_list(updatedStaffList);
            
            // Clear the selected staff
            setSelectedPayrollStaff(null);
            
            // Close the confirmation modal
            setShowConfirmModal(false);

          } else {
            // Close the confirmation modal and show error
            setShowConfirmModal(false);
            showErrorDialog(res.data);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        // Close the confirmation modal on error
        setShowConfirmModal(false);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  }

  const delete_allocation = (id) => {
    setIsLoading(true);
    genericPost(ENDPOINTS.DELETE_ALLOCATION, {
      "allocation_id": id
    })
      .then((res) => {
        console.log(res)
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {
            cogoToast.success("Allocation Deleted Successfully", {});


          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }
  const get_deductions = (_status) => {
    setIsLoading(true);

    genericGet(ENDPOINTS.LIST_DEDUCTIONS)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;

            setDeductionList(responseData);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });

  };
  const get_earnings = (_status) => {
    setIsLoading(true);

    genericGet(ENDPOINTS.LIST_EARNINGS)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;

            setEarningList(responseData);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });

  };
  const get_tags = (_status) => {
    setIsLoading(true);

    genericGet(ENDPOINTS.LIST_PAYROLL_SETUP)
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;

            setTags(responseData);
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });

  };
  const get_total_percentage = () => {

    let total = 0;
    lines.forEach((l) => {
      total = Number(total) + Number(l.percentage);
    })
    return total.toFixed(2);

  }
  const get_total_amount = () => {

    let total = 0;
    lines.forEach((l) => {
      total = Number(total) + Number(l.amount);
    })
    return total.toFixed(2);

  }



  const runPayroll = (track_id) => {
    setIsLoading(true)

    let data = {
      "track_id": track_id,
    }

    genericPost(ENDPOINTS.INITIALIZE_PAYROLL, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
            cogoToast.success(response.data.message, {
              hideAfter: 5,
            });

            setPayroll_staff_list(response.data.data);
            setPage(2);

          } else {
            cogoToast.error(response.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
        });
      });


  }


  const get_month_name = (month) => {

    const date = new Date(year, month - 1, 1);
    const month_name = date.toLocaleString('default', { month: 'long' });
    return month_name;
  }


  const listTracks = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.LIST_PAYROLL_TRACKS, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;

            setpayroll_tracks(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };


  const createTrack = () => {
    setIsLoading(true);
    genericPost(ENDPOINTS.CREATE_PAYROLL_TRACK, {
      "name": track_name,
      "month": month,
      "year": year,
      "payrolls": selectedTags
    })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {

            setshow_create_track_modal(false);
            listTracks();

          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const loadProjects = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.GET_PROJECT_CODES, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {

          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
            log("setproject_codes", responseData);
            // log("RIGHTS: ", responseData);
            setproject_codes(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const fetch_data = () => {
    setProcessing(true);


    genericGet(ENDPOINTS.LIST_EMPLOYEES)
      .then((res) => {

        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
       
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {

        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);





  return page == 1 ? <>
    <Loader loading={isLoading} />
    <div className="payroll-track-container">
      <div className="payroll-track-header">
        <h2>Payroll Tracks</h2>
        <button
          className="create-track-btn"
          onClick={() => setshow_create_track_modal(true)}
        >
          <FaPlusCircle /> New Payroll Track
        </button>
      </div>

      <div className="payroll-track-table">
        <div className="table-header">
          <div className="header-cell">Track Name</div>
          <div className="header-cell">Period</div>
          <div className="header-cell">Created</div>
          <div className="header-cell">Actions</div>
        </div>

        {payroll_tracks?.map((track) => (
          <div
            key={track.id}
            className="track-row"
            onClick={() => {
              setSelected_track_id(track.id);
              setSelected_track_name(track.name);
              runPayroll(track.id);
            }}
          >
            <div className="track-name">
              <span className="track-icon">
                <FaFileImport />
              </span>
              {track.name}
            </div>

            <div className="track-period">
              {new Date(track.year, track.month - 1).toLocaleString('default', { month: 'long' })} {track.year}
            </div>

            <div className="track-created">
              {new Date(track.created_at).toLocaleDateString()}
            </div>

            <div className="track-actions">
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                <FaArrowAltCircleRight className="action-icon" />
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Create Track Modal */}
      <Modal
        isOpen={show_create_track_modal}
        toggle={() => setshow_create_track_modal(false)}
        className="create-track-modal"
      >
        <ModalHeader toggle={() => setshow_create_track_modal(false)}>
          <h3>Create New Payroll Track</h3>
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Track Name</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter track name"
              value={track_name}
              onChange={(e) => setTrack_name(e.target.value)}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Month</label>
              <select
                className="form-input"
                value={month}
                onChange={(e) => setmonth(e.target.value)}
                required
              >
                <option value="">Select Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString('default', { month: 'long' })}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Year</label>
              <input
                type="number"
                className="form-input"
                placeholder="Enter year"
                min="2000"
                max="2100"
                value={year}
                onChange={(e) => setyear(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Payroll Types</label>
            <div className="payroll-types-grid">
              {tags.map((option) => (
                <label key={option.id} className="payroll-type-option">
                  <input
                    type="checkbox"
                    value={option.id}
                    onChange={handleCheckboxChange}
                    checked={selectedTags.includes(option.id)}
                  />
                  <span className="checkmark"></span>
                  {option.name}
                </label>
              ))}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="cancel-btn"
            onClick={() => setshow_create_track_modal(false)}
          >
            Cancel
          </button>
          <button
            className="submit-btn"
            onClick={createTrack}
            disabled={!track_name || !month || !year || selectedTags.length === 0}
          >
            Create Track
          </button>
        </ModalFooter>
      </Modal>
    </div>
  </>
    // END OF PAGE 1
    :
    // START PAGE 2 
    <>


      <div className="card" style={{ width: "100%", margin: "auto", padding: "20px", paddingTop: "5px" }}>


        <div className='col-md-12 mt-3 mb-3 row'>
          <div className='col-md-7'>
            <h1> <FaArrowCircleLeft style={{ display: "inline", color: "blue" }} onClick={() => {

              setPage(1);
              setSelectedPayrollStaff(null);

            }}></FaArrowCircleLeft> {selected_track_name} | EMPLOYEES:  ({payroll_staff_list?.length})  </h1>
          </div>
          {/* <div className='col-md-4'> */}
          <div className='col-md-2'>
            {selectedPayrollStaff == null ? <></> :
              <button style={{ float: "right" }} className='add-button btn-sm btn-success'
                onClick={handleSavePayrollClick}>
                <FaCheckCircle></FaCheckCircle> &nbsp;Save Payroll
              </button>
            }
          </div>
          <div className='col-md-2'>
            {selectedPayrollStaff == null ? <></> :
              <button style={{ float: "right" }} className='add-button btn-sm btn-danger'
                onClick={(e) => {
                  if (window.confirm("Are you sure you want to remove this Account for " + selectedPayrollStaff?.staff_details?.staff_name)) {
                    remove_account()
                  }

                }}><FaCheckCircle></FaCheckCircle> &nbsp;Deactivate Account
              </button>
            }
          </div>
          <div className='col-md-1'>
            {selectedPayrollStaff == null ? <></> :
              <button style={{ float: "right" }} className='add-button bnt-sm btn-danger btn-rounded'

                onClick={(e) => { setSelectedPayrollStaff(null) }}

              ><IconX size={25}></IconX>
              </button>
            }
          </div>
          {/* </div> */}
        </div>

        <div className="divider"></div>

        {/* {JSON.stringify(rowData)} */}

      
        <div className='row'>
          <div className='col-md-4'>
            <div className="ag-theme-alpine">
              <AgGridReact
                suppressMenuHide={true}
                ref={gridRef}
                onGridReady={(params) => {
                  setGridApi(params.api);

                }}
                rowData={payroll_staff_list}
                domLayout={"autoHeight"}
                animateRows={true}
                onRowClicked={(e) => {

                  setSelectedPayrollStaff(e.data);


                }}
                pagination={true}
                paginationPageSize={15}
                defaultColDef={defaultColDef}
                resizable={true}
                enableCellTextSelection={true}
                suppressCellSelection={true}
                columnDefs={[
                  {
                    headerName: "Staff Code",
                    field: "staff_details.staff_code",
                    sortable: true,
                    filter: true,
                    maxWidth: 150,
                  },
                  {
                    headerName: "Staff Name",
                    field: "staff_details.staff_name",
                    sortable: true,
                    filter: true,
                  },
                  {
                    headerName: "Office",
                    field: "staff_details.office_name",
                    sortable: true,
                    filter: true,
                  },
                  // {
                  //   headerName: "Budgeted",
                  //   field: "budget_months",
                  //   sortable: true,
                  //   filter: true,
                  // },
                  // {
                  //   headerName: "Salary",
                  //   field: "payroll_chargeable",
                  //   sortable: true,
                  //   filter: true,
                  // },

                ]}
              ></AgGridReact>
            </div>

          </div>
          {/* <div className='row'> */}


          <div className='col-md-8'>
          
            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered">
                <thead>
                  <tr>
                    <th
                      colSpan={6}
                      className="text-left bg-blue-lt"
                      style={{
                        fontSize: '1.1rem',
                        fontWeight: 600,
                        padding: '1rem',
                      }}
                    >
                      <IconUser size={20} className="mr-0" />
                      Employee Profile
                    </th>
                  </tr>
                  <tr>
                    <th style={{
                      fontSize: '10px',
                      fontWeight: 500,
                      padding: '5px',
                    }}>Staff ID</th>
                    <th>Staff Name</th>
                    <th>Role</th>
                    <th>Office</th>
                    <th>Contract End Date</th>
                    <th>Net Pay</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>
                      {selectedPayrollStaff?.staff_details?.staff_code}
                    </td>
                    <td>
                      {selectedPayrollStaff?.staff_details?.staff_name}
                    </td>
                    <td>
                      {selectedPayrollStaff?.staff_details?.role_name}
                    </td>
                    <td>
                      {selectedPayrollStaff?.staff_details?.office_name}
                    </td>
                    <td  >
                      {selectedPayrollStaff?.staff_details?.contract_end_date}
                    </td>
                    <td style={{ fontWeight: 'bold', color: 'blue' ,  }}>
                      <span style={{ fontWeight: 'bold', color: 'blue' ,backgroundColor: 'yellow' }}>$ {(calculatePayrollAmounts().net).toFixed(2)}

                  
                      </span>
 
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      <table className="table table-striped table-hover table-bordered">
                        <thead>
                          <tr>
                            <th
                              colSpan={6}
                              className="text-left bg-blue-lt"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                padding: '1rem',
                              }}
                            >
                              (<IconPlus size={20} className="mr-0" />)
                              EARNINGS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td >
                              Basic Salary{' '}
                              <IconHelpCircle 
                                id="basicSalaryHelp" 
                                size={16} 
                                style={{ cursor: 'pointer', color: '#6c757d', verticalAlign: 'middle' }} 
                              />
                              <UncontrolledTooltip placement="top" target="basicSalaryHelp">
                                This value comes from active contract uploaded to the system
                              </UncontrolledTooltip>
                            </td>
                            <td>
                              $ {selectedPayrollStaff?.earnings?.basic_salary ?? 0}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <u><h4>ALLOWANCES</h4></u>
                            </td>
                          </tr>
                          {selectedPayrollStaff?.earnings?.allowances?.allowances?.map((a) => {
                            return <tr>
                              <td>
                                {a?.name}
                              </td>
                              <td>
                                $ {a?.amount}
                              </td>
                            </tr>
                          })}
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>Total allowances</td>
                            <td>$ {selectedPayrollStaff?.earnings?.allowances?.total_allowances ?? 0}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>Contracted Salary</td>
                            <td><u>$ {selectedPayrollStaff?.earnings?.contracted_salary ?? 0} </u></td>
                          </tr>
                          <tr>
                            <td>
                              <div className="section-header">
                                <h4 >
                                  <u>ADJUSTED EARNINGS</u>
                                </h4>
                              </div>
                            </td>
                            <td>
                              <button
                                className="create-track-btn"
                                onClick={() => setShowAdjustmentEarningModal(true)}
                              >
                                <FaPlusCircle /> Add
                              </button>
                              {/* <button  onClick={() => setshow_create_track_modal(true)} className="add-button btn-success mt-2">
                                <IconPlus size={18} />
                                <span>Add</span>
                              </button> */}
                            </td>
                          </tr>
                          {selectedPayrollStaff?.earnings?.adjusted_earning?.adjusted_earning?.map((a) => {
                            return <tr>
                              <td>
                                {a?.name}
                              </td>
                              <td>
                                $ {a?.amount}
                              </td>
                            </tr>
                          })}

                          {selectedEarnings.map((earning) => (
                            <tr key={earning.id}>
                              <td>{earning.title}</td>
                              <td>
                                {earning.amount}
                              </td>

                            </tr>
                          ))}
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>Total adjusted earnings</td>
                            <td>$ {(
                              (selectedPayrollStaff?.earnings?.adjusted_earning?.adjusted_earning?.reduce(
                                (sum, a) => sum + parseFloat(a?.amount || 0), 0
                              ) || 0) +
                              selectedEarnings.reduce(
                                (sum, d) => sum + parseFloat(d.amount || 0), 0
                              )
                            ).toFixed(2)}</td>
                          </tr>

                          <tr>
                            <td colSpan={2}>
                              <u> <h4>BENEFITS</h4></u>
                            </td>
                          </tr>
                          {selectedPayrollStaff?.earnings?.retirement_benefits?.retirement_benefits?.map((a) => {
                            return <tr>
                              <td>
                                {a?.name}
                              </td>
                              <td>
                                $ {a?.amount}
                              </td>
                            </tr>
                          })}

                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>GROSS SALARY</td>
                            <td><u>$ {selectedPayrollStaff?.earnings?.gross_salary ?? 0} </u></td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>TOTAL PAYROLL AMOUNT</td>
                            <td><u style={{
                              textDecoration: 'none',
                              borderBottom: 'double 3px currentColor',
                              paddingBottom: '2px'
                            }}>$ {(selectedPayrollStaff?.total_staff_payroll +selectedEarnings.reduce(
                                (sum, d) => sum + parseFloat(d.amount || 0), 0
                              ))} </u></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td colSpan={3}>
                      <table className="table table-striped table-hover table-bordered">
                        <thead>
                          <tr>
                            <th
                              colSpan={6}
                              className="text-left bg-blue-lt"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                padding: '1rem',
                              }}
                            >
                              (<IconMinus size={20} className="mr-0" />)
                              DEDUCTIONS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={2}>
                              <u><h4>TAXES</h4></u>
                            </td>
                          </tr>
                          {selectedTaxes.map((tax) => (
                            <tr key={tax.id}>
                              <td>{tax.name}</td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={tax.amount ?? 0}
                                  onChange={(e) => handleUpdateTax(tax.id, e.target.value)}
                                  step="0.01"
                                  min="0"
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>Total taxes</td>
                            <td>$ {getTotalTaxes().toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td colSpan={2}>
                              <u> <h4>OTHER EXTRA DEDUCTIONS</h4></u>
                            </td>
                          </tr>
                          {selectedPayrollStaff?.deductions?.other_deductions?.other_deductions?.map((a) => {
                            return <tr>
                              <td>
                                {a?.name}
                              </td>
                              <td>
                                {a?.amount}
                              </td>
                            </tr>
                          })}
                          <tr>
                            <td  >Total extra deductions</td>
                            <td>$ {selectedPayrollStaff?.deductions?.other_deductions?.other_deductions_total ?? 0}</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="section-header">
                                <h4 >
                                  <u>ADJUSTED DEDUCTIONS</u>
                                </h4>
                              </div>
                            </td>
                            <td>
                              <button onClick={() => setShowAdjustmentDeductionModal(true)} className="add-button  btn-danger mt-2">
                                <IconPlus size={18} />
                                <span>Add</span>
                              </button>
                            </td>
                          </tr>
                          {selectedPayrollStaff?.earnings?.adjusted_deduction?.adjusted_deduction?.map((a) => {
                            return <tr>
                              <td>
                                {a?.name}
                              </td>
                              <td>
                                $ {a?.amount}
                              </td>
                            </tr>
                          })}
                          {selectedDeductions.map((deduction) => (
                            <tr key={deduction.id}>
                              <td>{deduction.title}</td>
                              <td>
                                {deduction.amount}
                              </td>

                            </tr>
                          ))}
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>Total adjusted deductions</td>
                            <td>$ {(
                              (selectedPayrollStaff?.earnings?.adjusted_deduction?.adjusted_deduction?.reduce(
                                (sum, a) => sum + parseFloat(a?.amount || 0), 0
                              ) || 0) +
                              selectedDeductions.reduce(
                                (sum, d) => sum + parseFloat(d.amount || 0), 0
                              )
                            ).toFixed(2)}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', color: '#066fa3' }}>TOTAL DEDUCTIONS</td>
                            <td>$ {(
                              (selectedPayrollStaff?.earnings?.adjusted_deduction?.adjusted_deduction?.reduce(
                                (sum, a) => sum + parseFloat(a?.amount || 0), 0
                              ) || 0) +
                              selectedDeductions.reduce(
                                (sum, d) => sum + parseFloat(d.amount || 0), 0
                              ) +

                              getTotalTaxes() +
                              (selectedPayrollStaff?.deductions?.other_deductions?.other_deductions_total || 0)
                            ).toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={6}>
                      <table className="table table-striped table-hover table-bordered">
                        <thead>
                          <tr>
                            <th
                              colSpan={5}
                              className="text-left bg-blue-lt"
                              style={{
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                padding: '1rem',
                              }}
                            >
                              <IconEyeDollar size={20} className="mr-0" />
                              SOURCES OF FUNDS
                            </th>
                          </tr>
                          <tr>
                            <th>Project</th>
                            <th>Budget</th>
                            <th>Budget Code</th>
                            <th>(%)</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedPayrollStaff?.sources?.map((source) => (
                            <tr key={source.id}>
                              <td>{source.project_name}</td>
                              <td>{source.budget_name}</td>
                              <td>{source.budget_line}</td>
                              <td>{source.percentage}%</td>
                              <td>$ {source.amount}</td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={3} style={{ fontWeight: 'bold', color: '#066fa3' }}>Total Sources</td>
                            <td colSpan={2}>
                              $ {selectedPayrollStaff?.sources?.reduce((acc, source) => acc + source.amount, 0) ?? 0}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {/* </div> */}
          
        </div>

        <Modal
          isOpen={show_adjustment_earning_modal}
          toggle={() => setShowAdjustmentEarningModal(false)}
          className="create-track-modal"
        >
          <ModalHeader toggle={() => setShowAdjustmentEarningModal(false)}>
            <h3>CREATE ADJUSTED EARNINGS</h3>
          </ModalHeader>
          <ModalBody>
            <div>
              {/* Dropdown to select an earning */}

              <div className="input-group mb-3">
                <select className='form-control'
                  value={selectedEarningId}
                  onChange={(e) => setSelectedEarningId(e.target.value)}
                >
                  <option value="">Select an earning</option>
                  {earning_list.map((earning) => (
                    <option key={earning.id} value={earning.id}>
                      {earning.title}
                    </option>
                  ))}
                </select>

                {/* Button to add the selected earning */}
                <button onClick={handleAddEarning} className='btn btn-primary'>Add</button>
              </div>
              {/* Table to display selected earnings */}
              <table className='info_table'>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Amount</th>
                    <th>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedEarnings.map((earning) => (
                    <tr key={earning.id}>
                      <td>{earning.title}</td>
                      <td>
                        <input
                          type="text"
                          value={earning.amount}
                          className='form-control'
                          onChange={(e) =>
                            handleUpdateEarning(earning.id, "amount", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className='form-control'

                          value={earning.remarks}
                          onChange={(e) =>
                            handleUpdateEarning(earning.id, "remarks", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <button onClick={() => handleRemoveEarning(earning.id)} className='btn btn-danger'>
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>


            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="submit-btn"
              onClick={() => setShowAdjustmentEarningModal(false)}
            >
              Save Adjustment Earnings
            </button>
            {/* <button
              className="submit-btn"
              onClick={createTrack}
              disabled={!track_name || !month || !year || selectedTags.length === 0}
            >
              Save Adjustment Earnings
            </button> */}
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={show_adjustment_deduction_modal}
          toggle={() => {
            setShowAdjustmentDeductionModal(false);
            // Clear form fields when modal closes
            setDeductionAmount("");
            setDeductionRemarks("");
            setSelectedDeductionId("");
          }}
          className="create-track-modal"
        >
          <ModalHeader toggle={() => {
            setShowAdjustmentDeductionModal(false);
            // Clear form fields when modal closes
            setDeductionAmount("");
            setDeductionRemarks("");
            setSelectedDeductionId("");
          }}>
            <h3>CREATE ADJUSTED DEDUCTIONS</h3>
          </ModalHeader>
          <ModalBody>
            <div >
              <h2>Adjusted Deductions</h2>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Deduction Type</label>
                  <select
                    className='form-control'
                    value={selectedDeductionId}
                    onChange={(e) => setSelectedDeductionId(e.target.value)}
                  >
                    <option value="">Select a deduction</option>
                    {deduction_list.map((deduction) => (
                      <option key={deduction.id} value={deduction.id}>
                        {deduction.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className='form-control'
                    placeholder="Enter amount"
                    value={deductionAmount}
                    onChange={(e) => setDeductionAmount(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && selectedDeductionId) {
                        handleAddDeduction();
                      }
                    }}
                    step="0.01"
                    min="0"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Remarks (Optional)</label>
                  <input
                    type="text"
                    className='form-control'
                    placeholder="Enter remarks"
                    value={deductionRemarks}
                    onChange={(e) => setDeductionRemarks(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && selectedDeductionId) {
                        handleAddDeduction();
                      }
                    }}
                  />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                  <button 
                    onClick={handleAddDeduction} 
                    className='btn btn-primary w-100'
                    disabled={!selectedDeductionId}
                  >
                    + Add
                  </button>
                </div>
              </div>
              {/* Deductions Table */}
              <table className='info_table'>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Amount</th>
                    <th>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedDeductions.map((deduction) => (
                    <tr key={deduction.id}>
                      <td>{deduction.title}</td>
                      <td>
                        <input
                          type="text"
                          className='form-control'
                          value={deduction.amount}
                          onChange={(e) =>
                            handleUpdateDeduction(deduction.id, "amount", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className='form-control'

                          value={deduction.remarks}
                          onChange={(e) =>
                            handleUpdateDeduction(deduction.id, "remarks", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <button onClick={() => handleRemoveDeduction(deduction.id)}
                          className='btn btn-danger'>
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className="submit-btn"
              onClick={() => setShowAdjustmentDeductionModal(false)}
            >
              Save Adjustment Deductions
            </button>
            {/* <button
              className="submit-btn"
              onClick={createTrack}
              disabled={!track_name || !month || !year || selectedTags.length === 0}
            >
              Save Adjustment Earnings
            </button> */}
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={show_alloc_details}
          style={{ maxWidth: '80%', width: '80%' }}
          onHide={() => setShowAdjustmentEarningModal(false)}

          backdrop={true}

        >
          <ModalHeader toggle={toggle2}>
            <div className="row">
              Previous Allocations
            </div>

          </ModalHeader>
          <ModalBody>

            {isLoading && <>Please wait...</>}


            <table className='info_table'>
              <thead>
                <th>Project</th>
                <th>Budget</th>
                <th>Budget Code</th>
                <th>Created By</th>
                <th>Percentage</th>
                <th>Amount</th>

                <th>..</th>
              </thead>

              {details_allocations?.map((p) => {
                return <tr>


                  <td>{p.project_name}</td>
                  <td>{p.project_name}</td>
                  <td>{p.budget_code}</td>
                  <td>{p.created_by}</td>
                  <td>{p.percentage}%</td>
                  <td>{p.amount}</td>
                  <td> <FaTimesCircle style={{ color: "red" }} onClick={() => {
                    if (window.confirm("Are you sure to delete this allocation?")) {
                      delete_allocation(p.id);
                    }
                  }}></FaTimesCircle> </td>
                </tr>
              })}

              <tr>
                <td colSpan={4}></td>
                <td>{get_detailed_alloc_total_percentage()}%</td>
                <td>${get_detailed_alloc_total_amount()}</td>

                <td></td>

              </tr>
            </table>
          </ModalBody>

        </Modal>
      </div>

      {/* Beautiful Payroll Confirmation Dialog */}
      <Modal isOpen={showConfirmModal} toggle={() => setShowConfirmModal(false)} centered size="lg">
        <ModalHeader toggle={() => setShowConfirmModal(false)} className="bg-success text-white">
          <i className="fas fa-check-circle me-2"></i>
          Confirm Payroll Save
        </ModalHeader>
        <ModalBody className="py-4">
          <div className="text-center mb-4">
            <i className="fas fa-user-check text-success" style={{ fontSize: '4rem' }}></i>
          </div>
          
          {/* Staff Information */}
          <Alert color="info" className="text-center mb-4">
            <h5 className="mb-2">
              <i className="fas fa-user me-2"></i>
              {selectedPayrollStaff?.staff_details?.staff_name || 'Unknown Staff'}
            </h5>
            <p className="mb-0 text-muted">
              Staff Code: <Badge color="primary">{selectedPayrollStaff?.staff_details?.staff_code || 'N/A'}</Badge>
            </p>
          </Alert>

          {/* Payroll Summary */}
          <div className="row mb-4">
            <div className="col-12">
              <h6 className="text-muted mb-3">
                <i className="fas fa-calculator me-2"></i>
                Payroll Summary:
              </h6>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Card className="border-primary text-center">
                <CardBody>
                  <i className="fas fa-dollar-sign text-primary mb-2" style={{ fontSize: '2rem' }}></i>
                  <h6 className="text-muted mb-1">Gross Pay</h6>
                  <h4 className="mb-0 text-primary fw-bold">
                    ${calculatePayrollAmounts().gross.toFixed(2)}
                  </h4>
                </CardBody>
              </Card>
            </div>
            <div className="col-md-4">
              <Card className="border-warning text-center">
                <CardBody>
                  <i className="fas fa-minus-circle text-warning mb-2" style={{ fontSize: '2rem' }}></i>
                  <h6 className="text-muted mb-1">Total Deductions</h6>
                  <h4 className="mb-0 text-warning fw-bold">
                    ${calculatePayrollAmounts().deductions.toFixed(2)}
                  </h4>
                </CardBody>
              </Card>
            </div>
            <div className="col-md-4">
              <Card className="border-success text-center">
                <CardBody>
                  <i className="fas fa-wallet text-success mb-2" style={{ fontSize: '2rem' }}></i>
                  <h6 className="text-muted mb-1">Net Pay</h6>
                  <h4 className="mb-0 text-success fw-bold">
                    ${calculatePayrollAmounts().net.toFixed(2)}
                  </h4>
                </CardBody>
              </Card>
            </div>
          </div>

          {/* Additional Details */}
          <div className="row mt-4">
            <div className="col-md-6">
              <Card className="border-info">
                <CardBody>
                  <h6 className="text-info mb-2">
                    <i className="fas fa-plus-circle me-2"></i>
                    Earnings ({selectedEarnings.length})
                  </h6>
                  {selectedEarnings.length > 0 ? (
                    <ul className="list-unstyled mb-0">
                      {selectedEarnings.map((earning, index) => (
                        <li key={index} className="d-flex justify-content-between">
                          <span>{earning.title}</span>
                          <span className="fw-bold">${parseFloat(earning.amount || 0).toFixed(2)}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-muted mb-0">No additional earnings</p>
                  )}
                </CardBody>
              </Card>
            </div>
            <div className="col-md-6">
              <Card className="border-danger">
                <CardBody>
                  <h6 className="text-danger mb-2">
                    <i className="fas fa-minus-circle me-2"></i>
                    Deductions ({selectedDeductions.length})
                  </h6>
                  {selectedDeductions.length > 0 ? (
                    <ul className="list-unstyled mb-0">
                      {selectedDeductions.map((deduction, index) => (
                        <li key={index} className="d-flex justify-content-between">
                          <span>{deduction.title}</span>
                          <span className="fw-bold">${parseFloat(deduction.amount || 0).toFixed(2)}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-muted mb-0">No additional deductions</p>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>

          {/* Warning Message */}
          <div className="text-center mt-4">
            <Alert color="warning">
              <i className="fas fa-exclamation-triangle me-2"></i>
              <strong>Important:</strong> This action will save the payroll as draft for this employee and remove them from the processing list. 
              
            </Alert>
          </div>

          {/* Loading Progress */}
          {isLoading && (
            <div className="text-center mt-4">
              <Alert color="info" className="d-flex align-items-center justify-content-center">
                <i className="fas fa-spinner fa-spin me-3" style={{ fontSize: '1.5rem' }}></i>
                <div>
                  <h6 className="mb-1">Processing Payroll...</h6>
                  <p className="mb-0 text-muted">Please wait while we save the payroll data.</p>
                </div>
              </Alert>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button 
            color="secondary" 
            onClick={() => setShowConfirmModal(false)}
            className="me-2"
            disabled={isLoading}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
          <Button 
            color="success" 
            onClick={handleConfirmSave}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fas fa-spinner fa-spin me-2"></i>
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-check me-1"></i>
                Confirm & Save Payroll
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Beautiful Error Dialog */}
      <Modal isOpen={showErrorModal} toggle={() => setShowErrorModal(false)} centered size="lg">
        <ModalHeader toggle={() => setShowErrorModal(false)} className="bg-danger text-white">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Payroll Processing Error
        </ModalHeader>
        <ModalBody className="py-4">
          <div className="text-center mb-4">
            <i className="fas fa-times-circle text-danger" style={{ fontSize: '4rem' }}></i>
          </div>
          
          {/* Main Error Message */}
          <Alert color="danger" className="text-center mb-4">
            <h5 className="mb-2">
              <i className="fas fa-exclamation-circle me-2"></i>
              {errorData?.message || 'An error occurred while processing payroll'}
            </h5>
          </Alert>

          {/* Error Details */}
          {errorData?.data && errorData.data.length > 0 && (
            <div className="mb-4">
              <h6 className="text-muted mb-3">
                <i className="fas fa-list me-2"></i>
                Error Details:
              </h6>
              <div className="row">
                {errorData.data.map((error, index) => (
                  <div key={index} className="col-12 mb-3">
                    <Card className="border-danger">
                      <CardBody>
                        <div className="d-flex align-items-start">
                          <div className="flex-shrink-0 me-3">
                            <i className="fas fa-user-times text-danger fs-4"></i>
                          </div>
                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 className="mb-1 text-danger">
                                  {error.staff_name || 'Unknown Staff'}
                                </h6>
                                <small className="text-muted">
                                  Staff Code: <Badge color="secondary">{error.staff_code || 'N/A'}</Badge>
                                </small>
                              </div>
                              <Badge color="danger" className="fs-6">
                                Error #{index + 1}
                              </Badge>
                            </div>
                            <div className="mt-2">
                              <p className="mb-0 text-danger fw-bold">
                                {error.message || 'No specific error message available'}
                              </p>
                            </div>
                          </div>
                        </div>

                     
                      </CardBody>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Summary */}
          <div className="text-center">
            <Alert color="info">
              <i className="fas fa-info-circle me-2"></i>
              <strong>Summary:</strong> {errorData?.data?.length || 0} employee(s) failed payroll processing. 
              Please review the errors above and take appropriate action before retrying.
            </Alert>
          </div>
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button 
            color="secondary" 
            onClick={() => setShowErrorModal(false)}
            className="me-2"
          >
            <i className="fas fa-times me-1"></i>
            Close
          </Button>
          <Button 
            color="primary" 
            onClick={() => {
              setShowErrorModal(false);
              // Add any retry logic here if needed
            }}
          >
            <i className="fas fa-redo me-1"></i>
            Review & Retry
          </Button>
        </ModalFooter>
      </Modal>
    </>
}
export default ProcessPayroll

